import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";
const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};
function AbstractPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Abstract</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              Wetlands (lakes, tanks, ponds, etc.), transitional lands linking
              hydrologically the terrestrial ecosystem with aquatic ecosystems
              with biophysical interactions, are the most productive and diverse
              ecosystems and provide numerous ecological, economic, and social
              benefits for human well-being. These vital ecosystems sustain
              ecological processes to provide services such as nutrient cycling,
              water purification, reducing pollution, carbon sequestration,
              groundwater recharge, provision of fish, fodder, fuel, and water,
              flood reduction, erosion control, aquatic biota habitats,
              education opportunities, aesthetics, and recreation. However, due
              to globalization, these fragile ecosystems are vulnerable to
              unplanned developmental activities and rapid urbanization, leading
              to large-scale land cover changes and hydrologic regimes. The
              sustained inflow of untreated wastewater (from the industrial and
              domestic sectors) into wetlands has altered the chemical
              integrity, which necessitates inventorying, mapping, and regular
              wetland monitoring to evolve conservation strategies. Integrating
              spatial and non-spatial data, analysis, and visualization with
              decision models through decision support systems enables informed
              decisions. In this context, the Bangalore Lake Information System
              (BLIS) is designed with information on water quality, biodiversity
              (microalgae, zooplankton, ichthyofauna, macrophytes, and birds),
              threats (encroachments, inflow of untreated sewage, etc.) and
              ecosystem services of lakes in Bangalore, Karnataka State, India.
              Rapid large-scale land use changes have resulted in an alteration
              in the hydrologic regime, the loss of habitats, and the
              disappearance of native species. BLIS empowers decision-making
              through knowledge of lake distribution in terms of the physical,
              chemical, and biological aspects and the value of ecosystem
              services, which is crucial for evolving strategies for prudent
              management of water bodies in Greater Bangalore.
            </p>
            <p>
              <strong>Keywords:</strong> BLIS, Lakes, Urbanization,
              Biodiversity, Restoration, Ecosystem services
            </p>
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default AbstractPage;
